export default{
  shopIndex:{
    Button:{
      postcard:"营业执照",
      chatLineSquare:"联系客服",
      collectId:"取消关注",
      collect:"关注店铺",
    },
    EntpInfoData:{
      entpName:"公司名称：",
      address:"公司地址：",
      contName:"联系人：",
      contTel:"联系电话：",
      contEmail:"联系邮箱：",
    },
    Placeholder:{
      saleCatgName:"请输入关键字"
    },
    shopCommCatgList:{
      title:"商品分类",
    },
    sort:{
      price:"价格排序",
      count:"销量",
      update:"更新时间"
    },
    Table:{
      egotiable:"面议",
      money:"元",
      end:"---到底了---"
    },
    Dialog:{
      title:"营业执照",
      button:"关闭"
    },
    Message:{
      shopCollect:"关注成功",
      shopCollectDel:"取消关注成功",
    }
    
  }
  
}